import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const outboundShipmentLocaleModule: LocaleModule = {
  name: "outboundShipment",
  messages: { en: en, it: it },
};
